module.exports = __webpack_public_path__ + "img/logoBlue.de67012b.png";